module.exports = __webpack_public_path__ + "img/course-cover.e6bae184.png";